import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RoundResultWriteRequest } from '~/apis/ssf';
import { SSF } from '~/apis/api';
import { keys } from './queries';

export function useCreateRoundResultMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.roundResultsCreate,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}

export function useUpdateRoundResultMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: ({ id, payload }: { id: number; payload: RoundResultWriteRequest }) =>
      SSF.api.roundResultsUpdate(id, payload),
    onSuccess: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}

export function useDeleteRoundResultMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: SSF.api.roundResultsDestroy,
    onSuccess: () => client.invalidateQueries({ queryKey: keys.lists() }),
  });
}
